<template>
    <header class="section header-area">
        <div id="appo-header" class="main-header-area">
            <div class="container-fluid">
                <nav class="navbar navbar-expand-md navbar-light">
                    <!-- Logo -->
                    <a class="navbar-brand" href="/">
                        <img class="logo" src="/assets/img/logo_header.svg" alt="">
                    </a>
                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#appo-menu">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="appo-menu">
                        <ul class="navbar-nav header-items mx-auto">
                            <li class="nav-item">
                                <a class="nav-link scroll" target="_blank" href="https://blog.forwardreceipts.com/">{{ $t('header.blog') }}</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link scroll" href="/#features">{{ $t('header.features') }}</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link scroll" href="/#pricing">{{ $t('header.subscription') }}</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link scroll" href="/#faq">{{ $t('header.faq') }}</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/contact">{{ $t('header.contact') }}</a>
                            </li>
                        </ul>
                        <ul class="navbar-nav header-actions align-items-md-center">
                            <li class="nav-item d-none d-md-block">
                                <LangSwitcher />
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    </header>
</template>

<script>
import LangSwitcher from '@/components/LangSwitcher/LangSwitcher'

export default {
  components: {
    LangSwitcher
  }
}
</script>

<style scoped>
.header-area {
    position: absolute;
}

.main-header-area {
    height: 74px;
}

.header-area .navbar {
    min-height: 74px;
}

.navbar-brand .logo {
    max-height: 34px;
}

.header-items .nav-link {
    color: #0a2a66;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0;
    padding: 0 20px;
}

.header-cta {
    background: var(--blue3);
    border-radius: 100px;
    box-shadow: 0 12px 24px rgba(7, 57, 234, 0.22);
    font-size: 13px;
    font-weight: 700;
    padding: 13px 26px;
}

@media (max-width: 767px) {
    .header-area {
        background: #fff;
        position: relative;
    }

    .header-items .nav-link {
        padding: 10px 0;
    }

    .header-cta {
        display: inline-block;
        margin-top: 12px;
    }
}
</style>
